module.exports = __webpack_public_path__ + "img/home-on.5465951c.png";